module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Bold.bcd021f7.ttf";